import CryptoJS from "crypto-js";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./RescheduleCancel.css";

function RescheduleCancel() {
  const { apptId } = useParams();
  console.log("apptId from URL:", apptId);
  const navigate = useNavigate();
  const [appointment, setAppointment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("useEffect running with apptId:", apptId);
    try {
      fetch(`${process.env.REACT_APP_API_URL}/lookup-booking`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          customer_added_date: apptId // apptId is the short hash from the URL
        })
      })
        .then(res => {
          if (!res.ok) {
            setError("Booking not found");
            return null;
          }
          return res.json();
        })
        .then(data => {
          if (data) setAppointment(data);
        })
        .catch(err => setError(err.message))
        .finally(() => setLoading(false));
    } catch (err) {
      console.error("Decryption error:", err);
      setError("Invalid booking link.");
      setLoading(false);
    }
  }, [apptId]);

  const handleReschedule = async () => {
    if (!appointment?.id) return;
    const confirm = window.confirm("This will clear your current timeslot and let you reschedule. Continue?");
    if (!confirm) return;

    await fetch(`${process.env.REACT_APP_API_URL}/cancel-booking`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ booking_id: appointment.id })
    });

    // Save all user information for the scheduler
    const userInfo = {
      firstName: appointment.firstName,
      lastName: appointment.lastName,
      email: appointment.email,
      phoneNumber: appointment.phoneNumber,
      streetAddress: appointment.streetAddress,
      city: appointment.city,
      zipCode: appointment.zipCode,
      recentAssessment: appointment.recentAssessment,
      electricityProvider: appointment.electricityProvider,
      gasProvider: appointment.gasProvider,
      fuelSource: appointment.fuelSource,
      rentOwn: appointment.rentOwn,
      multiUnit: appointment.multiUnit,
      referralCode: appointment.referralCode,
      otherInfo: appointment.otherInfo,
      customer_added_date: appointment.customer_added_date
    };

    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    console.log("Storing bookingId in localStorage:", appointment.id);
    localStorage.setItem("bookingId", appointment.id);
    localStorage.setItem("resumeSurvey", "true");  // Add this to indicate we're resuming from a reschedule
    navigate("/scheduler");
  };

  if (loading) return <p>Loading appointment...</p>;

  return (
    <div className="scheduler-container">
      <div className={`main-content${error ? ' blurred' : ''}`}> 
        {/* Top bar with company logo */}
        <div className="top-bar">
          <div className="logo">
            <img src="/colt-single-logo.png" alt="Colt Home Services" />
          </div>
        </div>
        <div className="scheduler">
          <h2>Manage Your Appointment</h2>
          <div className="confirmation-message">
            <p><strong>Date:</strong> {appointment?.audit_date || '--'}</p>
            <p><strong>Time:</strong> {appointment?.audit_time ? new Date(appointment.audit_time).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : '--'}</p>
            <div style={{ marginTop: '2rem', display: 'flex', justifyContent: 'center', gap: '1rem' }}>
              <button className="next-button" onClick={handleReschedule} disabled={!appointment}>Reschedule</button>
            </div>
          </div>
        </div>
      </div>
      {error && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Error</h3>
            <p>
              {error === "Booking not found"
                ? "We couldn't find your booking. Please contact Colt Home Services directly for assistance."
                : error}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default RescheduleCancel;

